export enum LoginProviders {
  GOOGLE = "google-oauth2",
  FACEBOOK = "facebook",
}
